// extracted by mini-css-extract-plugin
module.exports = {"RequestPasswordPage":"RequestPasswordPage"};